export default __webpack_public_path__ + "static/media/Edelweiss.e5bb36b7.webp";